/*import VueFileAgent from '@sonata/vue-file-agent'
import '@sonata/vue-file-agent/dist/vue-file-agent.css'
import UploadImage from 'vue-upload-image'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueFileAgent)
    nuxtApp.vueApp.component('upload-image', UploadImage)
    })
*/

import VueFileAgentNext from '@boindil/vue-file-agent-next'
import UploadImage from 'vue-upload-image'
   
import '@boindil/vue-file-agent-next/dist/vue-file-agent-next.css'
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueFileAgentNext)
    nuxtApp.vueApp.component('upload-image', UploadImage)
})